import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import './AdminProperties.css';

export default function AdminBrochures() {
  const [brochures, setBrochures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  
  const [formData, setFormData] = useState({
    title: '',
    file_url: ''
  });

  useEffect(() => {
    fetchBrochures();
  }, []);

  const fetchBrochures = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('brochures')
      .select('*')
      .order('created_at', { ascending: false });
      
    if (error) {
      console.error('Error fetching brochures:', error);
    } else {
      setBrochures(data || []);
    }
    setLoading(false);
  };

  const handleDelete = async (id, fileUrl) => {
    if (window.confirm('Are you sure you want to delete this brochure?')) {
      // 1. Delete from DB
      const { error } = await supabase
        .from('brochures')
        .delete()
        .eq('id', id);
        
      if (error) {
        alert('Error deleting brochure: ' + error.message);
      } else {
        fetchBrochures();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.file_url) {
      alert("Please fill all fields.");
      return;
    }

    // Insert into DB
    const { error: dbError } = await supabase
      .from('brochures')
      .insert([{ 
        title: formData.title, 
        size_label: 'Drive Link', 
        file_url: formData.file_url 
      }]);
      
    if (dbError) {
      alert('Error saving to database: ' + dbError.message);
    } else {
      setIsAdding(false);
      setFormData({ title: '', file_url: '' });
      fetchBrochures();
    }
  };

  if (loading) return <div>Loading brochures...</div>;

  return (
    <div className="admin-properties">
      {!isAdding ? (
        <>
          <button className="btn-add" onClick={() => setIsAdding(true)}>+ Add New Brochure</button>
          
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>File URL</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {brochures.map(b => (
                <tr key={b.id}>
                  <td>{b.title}</td>
                  <td>
                    <a href={b.file_url} target="_blank" rel="noopener noreferrer">View PDF</a>
                  </td>
                  <td>
                    <button className="btn-delete" onClick={() => handleDelete(b.id, b.file_url)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <div className="admin-form-container">
          <h3>Add New Brochure</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Title</label>
              <input 
                type="text" 
                value={formData.title} 
                onChange={(e) => setFormData({...formData, title: e.target.value})} 
                required 
              />
            </div>
            <div className="form-group">
              <label>Drive Link / URL</label>
              <input 
                type="url" 
                placeholder="https://drive.google.com/..."
                value={formData.file_url}
                onChange={(e) => setFormData({...formData, file_url: e.target.value})} 
                required 
              />
            </div>
            
            <div className="form-actions">
              <button type="submit" className="btn-save">Add Brochure</button>
              <button type="button" className="btn-cancel" onClick={() => setIsAdding(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
